import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { DeliveryOutcomeCtx } from '~/features/catalog-enrichment/utils/delivery-outcome-context';

const RunDeliveryPage = lazy(() => import('~/features/catalog-enrichment/pages/run-delivery-page'));

/** `dout` — the delivered-products list's outcome filter. */
const searchSchema = z.object({
  dout: z.string().optional().catch(undefined),
});

/** A batch's Delivery tab — sent, accepted, live, what the destination refused and why. */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/delivery',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const { dout } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DeliveryOutcomeCtx.Provider
      value={{
        value: dout ?? null,
        onChange: (next) => {
          void navigate({ search: (prev) => ({ ...prev, dout: next ?? undefined }) });
        },
      }}
    >
      <Suspense fallback={<PageSkeleton />}>
        <RunDeliveryPage runId={runId} />
      </Suspense>
    </DeliveryOutcomeCtx.Provider>
  );
}
